"use client"
import Image from "next/image"; 
import VpnVect from "../../../public/vpn.png"
import Link from "next/link";

const VpnHero = () => {
  return (
    <div className="custMargin">
    <div className="container">
      <div className="row d-flex align-items-center">
        <div className="col-lg-6 col-md-5 col-12">
          <div className="slogansnp">
            <h3 className="textHad fw-bold display-5">Temok VPN Services</h3>
              <p className="textPara fs-5 fw-normal my-2">  
              Defend Your Digital Privacy with Our  Reliable & Cheap VPN Services!
              </p>
            <h5 className="display-6">
              <strong className="text-success">Stay Safe, Stay Private!</strong>
            </h5>

            <Link
              href="#signup"
              className="btn btn-primary btn-lg hvr-bob button my-3 mx-0 orangeBtn"
            >
              <span>Get Started!</span>
            </Link>
          </div>
     
        </div>

        <div className="col-lg-6 col-md-7 col-12">
          <div className="borImg">
            <Image 
              src={VpnVect} 
              width={400}
              height={900}
              className="img-fluid"
              alt="VPN"
            />
          </div>
        </div>
      </div>
       <div className="clearfix"></div>

       <div className="text-center mt-5">
        <h4 className="textHad fw-bold display-6">
        Company Info
        </h4>
        <p className="textPara fs-4 fw-normal lh-md"> 
Temok is a team of professionals providing VPN services for 10+ years. Temok&apos;s affordable VPN plans will surprise you in 2024! With our cheap and Anonymous VPN services, you can reroute all of your website traffic using a secured and encrypted tunnel. We have plenty of satisfied clients worldwide. We protect you from hackers, spoofers, and cyber-attackers with our best anonymous VPN services. So, what are you waiting for? Choose one of our best and most affordable VPN plans from Temok VPN provider and enjoy an encrypted journey!
        </p>
       </div>
    </div>
    </div>
  );
};

export default VpnHero;
